<table class="table table-striped-columns">
  <tbody>
    <tr>
      <td width="120">Code:</td>
      <td>{{inqData.code}}</td>
    </tr>
    <tr>
      <td>Name:</td>
      <td>{{inqData.iname}} ({{inqData.gender}})</td>
    </tr>
    <tr>
      <td>Birth Date:</td>
      <td>{{inqData.dob}}</td>
    </tr>
    <tr>
      <td>Parents:</td>
      <td>F: {{inqData.father}}, M: {{inqData.mother}}</td>
    </tr>
    <tr>
      <td>Contact No.:</td>
      <td>{{inqData.mobile_no}}, {{inqData.alt_phone}}</td>
    </tr>
    <tr>
      <td>Email ID:</td>
      <td>{{inqData.email_id}}</td>
    </tr>
    <tr>
      <td>Address:</td>
      <td>{{inqData.address}},<br>{{inqData.city}}-{{inqData.pincode}},
        {{inqData.state}}, {{inqData.country}}</td>
    </tr>
    <tr>
      <td>Last Passout:</td>
      <td>{{dataService.getClassName(inqData.pass_class)}} Class ({{inqData.pass_marks}}%)
        in {{inqData.pass_year}} from {{inqData.pass_from}}</td>
    </tr>
    <tr>
      <td>New Class:</td>
      <td>{{dataService.getClassName(inqData.new_class)}} Class ({{inqData.new_session}})</td>
    </tr>
    <tr>
      <td>Inq. Source:</td>
      <td>{{inqData.inq_source}} on {{inqData.inq_date?.substr(0, 10)}}</td>
    </tr>
    <tr>
      <td>Note:</td>
      <td>{{inqData.inq_notes}}</td>
    </tr>
    <tr>
      <td>Status:</td>
      <td>{{dataService.getInqStatus(inqData.inq_status)}}</td>
    </tr>
    @for(fup of follow_ups; track $index;) {
    <tr>
      <th colspan="2">Follow Ups - {{dataService.ymd2dmy(fup.fup_date)}}</th>
    </tr>
    <tr>
      <td>Notes</td>
      <td>{{fup.fup_notes}}</td>
    </tr>
    <tr>
      <td>Lead Status</td>
      <td>{{dataService.getLeatStatus(fup.lead_status)}} <br> 
        <small>Mode: {{dataService.getInqMode(fup.fup_mode)}} by <b class="text-primary">{{getConsName(fup.fup_uid)}}</b></small></td>
    </tr>
    }
  </tbody>
</table>

<!-- <div class="w-100 d-flex justify-content-center gap-2 my-2">
  <button type="button" class="btn btn-success" (click)="editClick(inqData)"><i class="bi bi-pencil-square"></i>
    Edit</button>
  <button type="button" class="btn btn-danger" (click)="deleteClick(inqData.id)"><i class="bi bi-trash3"></i>
    Delete</button>
  <button type="button" class="btn btn-primary"><i class="bi bi-person-square"></i> Assign to</button>
</div> -->